import ForgotPassword from "../../components/forgotPassword";
import Login from "../../components/Login";
import EmailResetPassworrd from "../../components/emailResetPassword";

const authRoute = [
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "reset-password",
    element: <EmailResetPassworrd />,
  }

];

export default authRoute;
